import $ from "jquery"
import "bootstrap4-notify"
import Hook from "../hook"
import modalContentTemplate from "../../views/content/modals/modalGeneric.html"
import modalDimensionObjectSelector from "../../views/content/modals/modalDimensionObjectSelector.html"
import ModalDimensionObjectSelectorDialog from "../hooks/Modals/modalDimensionObjectSelectorDialog"
import ModalImage from "../hooks/Modals/modalImage"
import modalMailSendTemplate from "../../views/content/modals/modalMailSend.html"
import serializeForm from "../util/serializeForm"
const {newVueModal} = require("./vueModalInjector")
const {notify} = require("../util/notify")

window.mailTemplates = {}
window.mailToAddresses = []
window.predefinedEmails = []
window.mailTemplate = ""

/**
 * Modal class contains:
 * - modal instances (objects).
 * - listeners for modal related behaviors.
 * - listeners for modal view specific behaviors.
 * - methods related to the mail send dialog TODO: Move these to a seperate class
 * - views in modals usually are fully custom, and therefore are not always dynamic
 * @constant {element} extraLargeModal - Extra large modal element
 * @constant {element} largeModal - Large modal element
 * @constant {element} mediumModal - Medium modal element
 * @constant {element} smallModal - Small modal element
 * @property {bootstrap.Modal} extraLargeModalInstance - Extra large bootstrap native modal object
 * @property {bootstrap.Modal} largeModalInstance - Large bootstrap native modal object
 * @property {bootstrap.Modal} mediumModalInstance - Medium bootstrap native modal object
 * @property {bootstrap.Modal} smallModalInstance - Small bootstrap native modal object
 */
export default class modal {
  constructor() {
    /**
     * beforeMessage hook
     *
     * Currently contains a series of conditionals based on event types.
     * Each event type (could) result in showing a different modal content
     * TODO: make less messy
     */
    Hook.register("beforeMessage", this, async (window, event) => {
      const modalBodyID = "jjduej2383kmv"
      let modalTitle = ""
      let modalSize = "xl"

      mailToAddresses = []
      

      window.mailsSendToAddresses = []

      if (
        event.args &&
        event.args.fields &&
        event.args.fields[0].Name != "MailSendDialog"
      ) {
        modalSize = "sm"
      }

      if (
        event.args &&
        event.args.fields &&
        window.session.translations.ModalSendMailTitle
      ) {
        modalTitle = `${event.args.fields[4]} ${window.session.translations.ModalSendMailTitle}`
      }

      if (modalTitle != "") {
        const vueModal = await newVueModal({
          randomID: "adsfjosajf",
          modalBodyID,
          modalTitle,
          modalSize,
        })

        global.session.modal = vueModal

        await global.session.modal.$children[0].openModal()
      }

      let html
      let reportType
      let modalIdentifier =
        event.args && event.args.fields ? event.args.fields[0].Name : null

      // Catch Mail send request else render default content template
      if (
        event.type === "dialog" &&
        event.args &&
        event.args.fields &&
        event.args.fields[0].Name === "MailSendDialog"
      ) {
        reportType = "mailSend"

        html = modalMailSendTemplate.render(event)

        let predefinedEmailsReq = event.args.fields[7].PredefinedEmails
        if (predefinedEmailsReq && predefinedEmailsReq.length > 0) {
          predefinedEmailsReq.forEach(email => {
            predefinedEmails.push(email)
          })
        } else if (predefinedEmailsReq.length == 0) {
          predefinedEmails.splice(0, predefinedEmails.length) // clear predefinedEmails if current request has none
        }
      } else if (modalIdentifier === "DimensionObjectSelectorDialog") {
        let modalDimensionObjectSelectorDialogInstance = new ModalDimensionObjectSelectorDialog()
        html = modalDimensionObjectSelector.render(event)
      } else {
        html = modalContentTemplate.render(event)
      }

      if (event.type !== "error" && event.type !== "warning") {
        // Set mailtemplates

        if (event.args.fields[0].Name == "MailSendDialog") {
          if (event.args.fields[2].DropdownItems) {
            event.args.fields[2].DropdownItems.forEach(mailTemplate => {
              mailTemplates[mailTemplate.Value.replace(/\s/g, "")] =
                mailTemplate.Attributes.Body
            })
          }
          // Set Modal content
          $(`#${modalBodyID}`).html(html)
        } else {
          $(`#${modalBodyID}`).html(html)
        }

        this.registerListeners()

        // Restore data from previous opening
        if (event.args.fields[0].Name == "MailSendDialog") {
          //this.restoreMailTo()
          //this.restoreMailTemplate()
        }
        if (reportType === "mailSend") {
          event.form = await new Promise(resolve =>
            $(`#${modalBodyID}`)
              .find("form")
              .data("promise-resolver", resolve),
          ).then()
        } else {
          event.form = await new Promise(resolve =>
            $(`#${modalBodyID}`)
              .find("form")
              .data("promise-resolver", resolve),
          ).then()
        }
      } else {
        notify({message: event.message, type: event.type})
      }
    })

    $("body").on("click", ".modal [data-dismiss='modal']", () => {
      global.session.modal.$children[0].closeModal()
      session.activeWindow.toggleLoading(false)
    })

    $(document).on("click", ".close", () => {
      this.closeProcedure()
      session.activeWindow.toggleLoading(false)
    })

    $(document).on("click", ".modal-backdrop", () => {
      session.activeWindow.toggleLoading(false)
    })

    $(document).on("click", ".modal fade show", () => {
      session.activeWindow.toggleLoading(false)
    })

    $("body").on(
      "submit",
      ".modal form#modalMailSend",
      async function sendMail() {
        let requestUrl = "/Admin/Webservices/ActionWebservices.asmx/MailRows"
        let data = null

        if (!$(this).hasClass("simple")) {
          data = serializeForm(this, mailToAddresses)
        }

        let request = {Subject: data.Subject}
        debugger
        let selectionInfo = {
          Request: request,
          ActionName: "MailReport",
          Arguments: {
            EmailTemplateID: data.EmailTemplateID,
            EmailTo0: data.extraValues,
            EmailCC0: null,
            EmailBCC0: null,
            EditMail0: false,
            ReportID: data.ReportID,
            MailTemplate: data.mailTemplate,
          },
          Selection: [],
          Data: {
            Selection: [
              {
                [data.PrimaryKey]: data.PrimaryKeyValue, // using [] for the key let's us create a dynamic object key
              },
            ],
          },
        }
        let requestData = {selectionInfo: selectionInfo}
        let result = await window.session.request(requestUrl, requestData)
        if (result.IsActionResponse) {
          notify({
            message: window.session.translations.mailsSend,
            type: result.Events[0][1],
          })

          await global.session.modal.$children[0].closeModal()
        } else {
          notify({message: result.ErrorMessage, type: event.type})
        }
      },
    )

    $("body").on(
      "submit",
      ".modal form#modalGenericSend",
      async function sendMail() {
        let resolve = $(this).data("promise-resolver")
        let output = null

        if (!$(this).hasClass("simple")) {
          output = serializeForm(this)
        }
        resolve(output)
        await global.session.modal.$children[0].closeModal()
      },
    )

    /**
     * Checks for user input on the EmailTemplateID.
     * If user makes a change in the input field we draw the new EmailTemplate in the modal.
     */
    $("body").on("change", "input[name='EmailTemplateID']", event => {
      $(document)
        .find("#mailTemplate")
        .html(window.mailTemplates[event.target.value.replace(/\s/g, "")])
    })

    /**
     * Register listeners for Modal Images
     */
    let modalImageInstance = new ModalImage()
    modalImageInstance.registerEventListeners()
  }

  /**
   * Restore mail template
   *
   * If a mail template was selected in an earlier session restore it
   * @returns {void}
   */
  restoreMailTemplate() {
    $("div[name='mailTemplate']").html(window.mailTemplate)
  }

  /**
   * addMailTo
   *
   * Add email addresses from the email list
   * @param {String} mailAddress An email address
   * @returns {void} Returns nothing
   */
  addMailTo(mailAddress) {
    let emailToList = document.querySelector("#emailToList")
    let mailTo = document.createElement("li")
    let mailToIcon = document.createElement("i")

    mailToIcon.setAttribute(
      "class",
      "text-danger fa fa-trash removeMailTo pull-right",
    )

    if (document.createTextNode(mailAddress) != null) {
      mailTo.appendChild(document.createTextNode(mailAddress))
    }

    if (mailToIcon != null) {
      mailTo.appendChild(mailToIcon)
    }

    if (mailTo != null) {
      emailToList.appendChild(mailTo)
    }

    mailToIcon.addEventListener("click", event => {
      event.target.parentNode.remove()
      this.removeMailTo(event)
    })
  }

  /**
   * removeMailTo
   *
   * Remove email addresses from the email list
   * @param {Element} event The element that's clicked in the GUI (bin icon)
   * @returns {void} Returns nothing
   */
  removeMailTo(event) {
    // this.emailToList.splice($.inArray(event.target.value, this.emailToList), 1)
    for (let i = 0; i < window.mailToAddresses.length; i++) {
      if (window.mailToAddresses[i] === event.target.parentNode.innerText) {
        window.mailToAddresses.splice(i, 1)
        break
      }
    }
    event.target.parentNode.remove()
  }

  /**
   * registerListeners
   *
   * Register all listeners related to the opened modal
   * @returns {void} Returns nothing
   */
  registerListeners() {
    let addMailAddress = document.querySelector("input[name='mailAddress']")

    $("input[name='Contact']").on("change", async event => {
      if (this.emailValidation($(event.target).val())) {
        if (!mailToAddresses.includes($(event.target).val())) {
          mailToAddresses.push($(event.target).val())
          this.addMailTo($(event.target).val())
          $(event.target).val = ""
          $(document)
            .find("#notifyDialog")
            .hide()
        }
      } else {
        if ($(event.target).val() != "") {
          this.notify("This contact has an invalid mail address configured")
          $(event.target).val = ""
        }
      }
    })

    // $("body").find("#mailTemplate").on("change keyup", (event) => {
    // 	// const delay = ms => new Promise(res => setTimeout(res, ms))
    // 	window.mailTemplate = $(event.target).html()
    // })

    $(document)
      .find(".list-contacts")
      .on("keydown", event => {
        if (event.keyCode === 13) {
          // const delay = ms => new Promise(res => setTimeout(res, ms))
          event.preventDefault()
          return false
        }
      })

    /**
     * Process new mailAdress
     *
     * Listens for: Enter key
     * When a new mailaddress is added validate it on being a correct email address and add it to the array and DOM.
     */
    $("body")
      .find(addMailAddress)
      .on("keydown", event => {
        if (event.keyCode === 13) {
          if (this.emailValidation(event.target.value)) {
            mailToAddresses.push(event.target.value)
            this.addMailTo(event.target.value)
            event.target.value = ""
            $(document)
              .find("#notifyDialog")
              .hide()
          } else {
            this.notify("Invalid mailadres entered, please try again")
          }
        }
      })

    /**
     * Prevent form submission when adding email addresses
     *
     * Listens for Enter key
     */
    $("#modailMailSend").keypress(event => {
      if (event.keyCode === 10 || event.keyCode === 13) {
        event.preventDefault()
      }
    })
  }

  /**
   * closeProcedure
   *
   * Closes the loading animation in the window element
   * @returns {void} Returns nothing
   */
  closeProcedure() {
    $(".window-body")
      .find(".cover")
      .fadeOut(300, () => {
        $(this).remove()
      })
    global.session.activeWindow.toggleLoading(false)
  }

  /**
   * emailValidation
   *
   * Validates the provided email address using a Regex match
   * @param {string} email  An email address to validate on its validity
   * @returns {boolean} True or false
   */
  emailValidation(email) {
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
    return regex.test(email)
  }

  /**
   * notify
   *
   * Sends a message in the model when the element exists
   * @param {string} message The message displayed in the element
   * @returns {void}
   */
  notify(message) {
    $(document)
      .find("#notifyDialogContent")
      .html(message)
    $(document)
      .find("#notifyDialog")
      .show()
  }
}
